<template>
  <router-view />
  <ReloginDialog />
</template>

<script setup>
import { onMounted, onUnmounted } from 'vue'
import ReloginDialog from '@/components/ReloginDialog.vue'

const themeMedia = window.matchMedia("(prefers-color-scheme: dark)")
const handleThemeChange = (e) => {
  if (e.matches) {
    document.documentElement.classList.add('dark')
    console.log('dark')
  } else {
    document.documentElement.classList.remove('dark')
    console.log('light')
  }
};


themeMedia.addEventListener('change', handleThemeChange)

onMounted(() => {
  document.querySelector('#loader-wrapper')?.remove()
})
onUnmounted(() => {
  themeMedia.removeEventListener('change', handleThemeChange)
});
</script>
